import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getToken } from "./Common.jsx";

// handle the private routes
function PrivateRoute({ component: Component, ...rest }) {
  const token = getToken();
  
  console.log('🔐 PrivateRoute - Path:', rest.path, 'Token:', token ? 'Present' : 'Missing');
  
  return (
    <Route
      {...rest}
      render={(props) => {
        console.log('🔐 PrivateRoute - Rendering:', rest.path, 'Token:', token ? 'Present' : 'Missing');
        return token ? (
          <>
            {console.log('🔐 PrivateRoute - Rendering Component:', Component.name)}
            <Component {...props} />
          </>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
}

export default PrivateRoute;
